import message from "@/utils/globalMessage";
import React, { useEffect, useState } from "react";
import { Button, Spin } from "antd";
import { previewFacilityReport } from "@/redux/api";
import { usePdfContext } from "@containers/PdfReport/context";

const ReportLoading = () => {
  const [loading, setLoading] = useState(false);
  const { pdfFormValue, setPreviewUrl, goToFormStep, goToViewStep } = usePdfContext();

  useEffect(() => {
    let mounted = true;
    const run = async () => {
      setLoading(true);
      try {
        const response = await previewFacilityReport(pdfFormValue);
        const url = URL.createObjectURL(response.data);
        if (mounted) {
          setPreviewUrl(url);
          goToViewStep();
        }
      } catch (error) {
        message.error("Preview failed");
        if (mounted) {
          goToFormStep();
        }
      } finally {
        if (mounted) {
          setLoading(false);
        }
      }
    };
    run();
    return () => {
      mounted = false;
    };
  }, [goToFormStep, goToViewStep, pdfFormValue, setPreviewUrl]);

  return (
    <div style={{ display: "flex", minHeight: 400, alignItems: "center", justifyContent: "center", flexDirection: "column", gap: 16 }}>
      <Spin spinning={loading} size="large" />
      <div>Generating report preview...</div>
      <Button onClick={goToFormStep}>Back</Button>
    </div>
  );
};

export default ReportLoading;
